/** Builders for links into the live WarEra web app. Centralised so the base
 * URL and path shapes live in one place (client + worker both import this). */

export const WARERA_APP_BASE = "https://app.warera.io";

/** Public profile page for a WarEra user. */
export function wareraUserUrl(userId: string): string {
  return `${WARERA_APP_BASE}/user/${userId}`;
}

/** Public article (campaign post) page. */
export function wareraArticleUrl(articleId: string): string {
  return `${WARERA_APP_BASE}/article/${articleId}`;
}

/** WarEra entity ids are Mongo ObjectIds: 24 hex characters. */
const OBJECT_ID = /^[0-9a-f]{24}$/i;

/**
 * The battle id from whatever a player pasted. They reach for the address bar,
 * so `https://app.warera.io/battle/<id>` is the normal input, not the bare id.
 * Returns null when no id can be found, so callers reject with a clear message
 * instead of sending nonsense upstream.
 */
export function parseBattleId(input: string): string | null {
  const trimmed = String(input ?? "").trim();
  if (OBJECT_ID.test(trimmed)) return trimmed;
  const match = trimmed.match(/battle\/([0-9a-f]{24})/i);
  return match ? match[1] : null;
}
